export default "__VITE_ASSET__B3O8tp4l__"